const companyData = [
  { label: '会社名', value: '株式会社atco' },
  { label: '住所', value: '東京都新宿区西新宿6丁目5番1号\n新宿アイランドタワー2階' },
  { label: '設立', value: '2018年6月1日' },
  { label: '資本金', value: '600万円' },
  { label: '取締役', value: '代表取締役 小林 満' },
  { label: '事業内容', value: '・広告運用代行\n・ビジネスマッチング支援\n・学習塾の運営\n（2024年4月に閉館後現在は再開検討中）' },
];

const CompanySection = () => {
  return (
    <section id="company" className="py-20 bg-[#f7f9f7]">
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
          <div>
            <p className="text-[#3d6b4f] text-xs font-semibold tracking-widest uppercase mb-3">Company</p>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8">会社概要</h2>
            <div className="border-t border-gray-200">
              {companyData.map((row) => (
                <div key={row.label} className="flex border-b border-gray-200 py-4">
                  <div className="w-28 flex-shrink-0 text-xs font-semibold text-gray-500">{row.label}</div>
                  <div className="text-sm text-gray-800 whitespace-pre-line">{row.value}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="w-full h-[340px] rounded-lg overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/a368510d5c22097dde86703293277a63.jpg"
              alt="会社概要"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanySection;
